import type { ReactElement } from 'react';
import { EntityType } from 'packages/store/sharing/types';

export enum GroupAccessEntry {
    ALL_USERS = 'ALL_USERS',
    RESTRICTED = 'RESTRICTED',
}

export type GroupAccessDropdownItem = {
    key: GroupAccessEntry;
    icon: ReactElement;
    title: ReactElement;
    subtitle: ReactElement;
};

export type Props = {
    onSelect: (key: GroupAccessEntry) => void;
    restriction: GroupAccessEntry;
    isDisabled: boolean;
    entityType: EntityType;
};
